import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import { EDITOR_HOST } from '../../links';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(23, 0),
    backgroundImage:
      'radial-gradient(76.72% 165.16% at 22.62% 38.54%, #764CEE 0%, #2C1962 100%)'
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  title: {
    marginBottom: theme.spacing(8),
    color: theme.palette.common.white,
    transitionDelay: '0.1s'
  },
  button: {
    transitionDelay: '0.4s'
  }
}));

const CreateARBlock = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#editorCreatedBlock"
            indicators={false}
            reverse={false}
            offset="-200px"
          >
            <div id="editorCreatedBlock">
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography
                  className={clsx(classes.title, classes.animate)}
                  variant="h2"
                  align="center"
                >
                  {t('editorPage.createBlock.title')}
                </Typography>
                <Button
                  className={clsx(classes.button, classes.animate)}
                  variant="contained"
                  href={EDITOR_HOST}
                >
                  {t('editorPage.createBlock.button')}
                </Button>
              </Box>
            </div>
          </Scene>
        </Controller>
      </Container>
    </div>
  );
};

export default CreateARBlock;
